import { handleActions } from "redux-actions";

import { setBrands } from "./actions";

const initialState = {
    isLoadingBrand: false,
    codes: [],
    brands: {}
};

export const brandReducer = handleActions(
    {
        [setBrands]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);